import { Card, Flex, Select } from "antd"
import React from "react"

import { SearchBar } from "../../../../../../../components/Input/SearchBar.tsx"
import {
  OrderingDropdown,
  type OrderingDropdownOption
} from "../../../../../../../components/Shared/OrderingDropdown.tsx"
import { type AlbumsFilters } from "../../../../../../Album/redux/album.types.ts"
import type { AlbumListItem } from "../../../../../../Album/types/album.types.ts"

const VISIBILITY_OPTIONS = [
  { value: null, label: "All" },
  { value: "true", label: "Visible to client" },
  { value: "false", label: "Hidden" }
]

// const { Text } = Typography
//
// const quickFilters = [
//   "Photos Only",
//   "PDFs Only",
//   "By Task",
//   "By Budget",
//   "This Week"
// ]

interface ProjectAlbumsFiltersProps {
  filters: AlbumsFilters
  sortOptions: OrderingDropdownOption<AlbumListItem>[]
  showVisibilityFilter: boolean
  onFiltersChange: (data: Partial<AlbumsFilters>) => void
}

export function ProjectAlbumsFilters({
  filters,
  sortOptions,
  showVisibilityFilter,
  onFiltersChange
}: ProjectAlbumsFiltersProps) {
  const onFilterChange = (key: keyof AlbumsFilters) => (value: unknown) => {
    onFiltersChange({ [key]: value || null })
  }

  return (
    <Card classNames={{ body: "p-2 space-y-2" }}>
      <Flex justify="space-between" align="center" wrap="wrap" gap={"small"}>
        <Flex align="center" gap={"middle"} wrap="wrap">
          {/*<Segmented*/}
          {/*  options={[*/}
          {/*    { label: "Albums", value: "Albums" },*/}
          {/*    { label: "Grid", value: "Grid", icon: <AppstoreOutlined /> },*/}
          {/*    {*/}
          {/*      label: "List",*/}
          {/*      value: "List",*/}
          {/*      icon: <UnorderedListOutlined />*/}
          {/*    }*/}
          {/*  ]}*/}
          {/*/>*/}
          <SearchBar
            placeholder="Search albums..."
            className="w-48 md:w-64"
            defaultValue={filters?.q || ""}
            onSearch={onFilterChange("q")}
          />
          {/*<Flex align="center" gap={8}>*/}
          {/*  <Text type="secondary">View:</Text>*/}
          {/*  <Select*/}
          {/*    defaultValue="all"*/}
          {/*    style={{ width: 120 }}*/}
          {/*    options={[*/}
          {/*      { value: "all", label: "All Files" },*/}
          {/*      { value: "images", label: "Images" },*/}
          {/*      { value: "documents", label: "Documents" }*/}
          {/*    ]}*/}
          {/*  />*/}
          {/*</Flex>*/}
        </Flex>
        <Flex align="center" gap={12}>
          {showVisibilityFilter && (
            <Select
              value={filters?.is_visible_to_customer || null}
              style={{ width: 150 }}
              onChange={onFilterChange("is_visible_to_customer")}
              options={VISIBILITY_OPTIONS}
            />
          )}
          {/*<Button disabled icon={<FilterOutlined />}>*/}
          {/*  Filter*/}
          {/*</Button>*/}
          <OrderingDropdown<AlbumListItem>
            ordering={filters?.ordering || null}
            sortOptions={sortOptions}
            onOrderingChange={onFilterChange("ordering")}
          />
        </Flex>
      </Flex>

      {/*/!* Quick Filters *!/*/}
      {/*<Flex gap={8} wrap="wrap" align={"center"}>*/}
      {/*  <Text type="secondary" className="mr-2">*/}
      {/*    Quick Filters:*/}
      {/*  </Text>*/}
      {/*  {quickFilters.map((filter) => (*/}
      {/*    <Tag*/}
      {/*      key={filter}*/}
      {/*      className={`cursor-pointer px-3 py-1 rounded-full border`}*/}
      {/*      // activeFilters.includes(filter)*/}
      {/*      // ? "bg-teal-50 border-teal-500 text-teal-700"*/}
      {/*      // : "bg-white hover:border-teal-500"*/}
      {/*    >*/}
      {/*      {filter}*/}
      {/*    </Tag>*/}
      {/*  ))}*/}
      {/*</Flex>*/}
    </Card>
  )
}
